// extracted by mini-css-extract-plugin
export default {"iconItem":"StandardIconDropDown_iconItem__kgv5+","dropdownMenu":"StandardIconDropDown_dropdownMenu__9xoei","dropdownItem":"StandardIconDropDown_dropdownItem__62Z3T"};